import { render, staticRenderFns } from "./addStockTransfer.vue?vue&type=template&id=4d2a6560&scoped=true&"
import script from "./addStockTransfer.vue?vue&type=script&lang=js&"
export * from "./addStockTransfer.vue?vue&type=script&lang=js&"
import style0 from "./addStockTransfer.vue?vue&type=style&index=0&id=4d2a6560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a6560",
  null
  
)

export default component.exports